<template>
    <div>
        <empty-table-message v-if="this.contasFlex.length === 0" />
        <b-table
            v-else
            :data="contasFlex"
            class="data-table table-overflow"
            @sort="sortTable"
            backend-sorting
            striped
        >
            <b-table-column
                v-for="(f, i) in fields"
                :key="i"
                :field="f.key"
                :label="$t(f.label)"
                :width="f.width"
                :sortable="f.sortable"
                :visible="f.visible"
                v-slot="props"
                :header-class="
                    f.key == 'label' && !isMobile() ? 'remove-space' : ''
                "
                :cell-class="
                    f.key == 'label' && !isMobile() ? 'remove-space' : ''
                "
            >
                <template v-if="f.key === 'idVenFlexErp' || f.key === 'nomeUsuario' || f.key === 'nomeEmpresa'">
                    <router-link
                        :to="{
                            name: 'flex-detail',
                            params: { id: props.row.id },
                        }"
                    >
                        <pre>{{ props.row[f.key] }}</pre>
                    </router-link>
                </template>
                <template
                    v-else-if="
                        f.key === 'saldoTotalLiberado' ||
                        f.key === 'valorMinimo' ||
                        f.key === 'saldoTotalBloqueado'
                    "
                >
                    {{
                        new Intl.NumberFormat("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                        }).format(props.row[f.key])
                    }}
                </template>
                <template v-else-if="f.key === 'datahoraalt'">
                    {{
                        props.row[f.key]
                            ? $moment(props.row[f.key]).format("L LT")
                            : "--"
                    }}
                </template>
                <template v-else-if="f.key == 'situacao'">
                    <div class="is-flex is-flex-hright g-2">
                        <b-button
                            type="is-success"
                            icon-right="currency-usd"
                            @click="
                                $emit('showFlexLancamentoModal', props.row)
                            "
                            v-tippy 
                            :title="$t('lancamento-manual')"
                        />

                        <b-tag
                            class="table-tag w-70"
                            :type="
                                props.row[f.key] == 1
                                    ? 'is-success'
                                    : 'is-danger'
                            "
                            size="is-medium"
                        >
                            {{
                                props.row[f.key] == 1
                                    ? $t("ativo")
                                    : $t("inativo")
                            }}
                        </b-tag>
                        <span>
                            <b-button
                                class="action-button"
                                :type="
                                    props.row['situacao'] == 1
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['situacao'] == 1
                                        ? 'delete'
                                        : 'check'
                                "
                                @click="
                                    $emit('promptChangeSituacao', props.row)
                                "
                                v-tippy 
                                :title="$t(
                                    props.row['situacao'] == 1
                                        ? 'desativar'
                                        : 'reativar'
                                )"
                            />
                        </span>
                    </div>
                </template>
                <template v-else>
                    {{ props.row[f.key] }}
                </template>
            </b-table-column>
        </b-table>
    </div>
</template>
<script>
export default {
    name: "FlexListTable",
    props: {
        contasFlex: {
            type: Array,
            default: (_) => [],
        },
        callShowModal: {
            type: Function,
            default: () => {},
        },
        isMobile: {
            type: Function,
            default: () => {},
        },
        sortTable: {
            type: Function,
            default: () => {},
        },
        isEmpty: {
            type: Boolean,
            default: true,
        },
        isLoading: {
            type: Boolean,
            default: true,
        },
        cameFrom: {
            type: String,
            default: "route",
        },
        fields: {
            type: Array,
            default: [],
        },
    },
};
</script>
<style lang="scss">
@media screen and (min-width: 760px) {
    .table-overflow {
        .table {
            min-width: 990px;
            .remove-space {
                padding-left: 0;
                margin-left: 0;
                padding-right: 0;
                margin-right: 0;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.w-70 {
    width: 70px;
}
.g-2 {
    gap: 8px;
}
// Barra de filtro
.label-situacao {
    position: absolute;
    bottom: 5px;
    top: 5px;
    display: flex;

    .bar {
        border-radius: 100px;
        width: 5px;
        min-height: 25px;
        height: 100%;
        &.bar-finalizada {
            background-color: #84bd42;
        }
        &.bar-aberta {
            background-color: #fd5858;
        }
    }
}
.sovis-tag {
    display: inline-block;
    text-transform: capitalize;
    text-align: center;
    font-size: 11px;
    padding: 3px 5px;
    border-radius: 4px;
    color: #fff;
    margin: 1px;
    cursor: pointer;

    &.is-success {
        background-color: $green-alert;
    }
    &.is-danger {
        background-color: $orange;
    }
}
.sovis-container-user {
    cursor: pointer;
    padding: 2px 10px;
    border: solid 1px $primary-color;
    background-color: #f0f0f0;
    border-radius: 6px;
    display: flex;
    position: absolute;
    @media screen and (max-width: 850px) {
        position: relative;
    }
    .qtd-users {
        font-weight: bolder;
        font-size: 18px;
        margin: 0 10px;
        &.is-success {
            color: $green-alert;
        }
        &.is-danger {
            color: $orange;
        }
    }
}
</style>
